"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// export function customRendererCss(instance, td, row, col, prop, value, cellProperties) {
//     // 清空单元格内容
//     while (td.firstChild) {
//       td.removeChild(td.firstChild);
//     }
//     const container = document.createElement('div');
//     container.className = 'icon-container';

//     const icon = document.createElement('i');
//     icon.className = 'icon iconxiugai'; // 设置图标的 CSS 类
//     container.appendChild(icon);
//     const textSpan = document.createElement('span');
//     textSpan.className = 'text-content';
//     textSpan.textContent = value; // 设置文本内容
//     textSpan.title = value; // 设置 tooltip 文本
//     container.appendChild(textSpan);
//     td.appendChild(container);

//   }

//  const hotTableClickEdit = function(hot){
//     hot.hotInstance.addHook('afterOnCellMouseDown', (event,coords) =>{
//       if (coords.row < 0 || coords.col<0) return;
//          hot.startEdit(coords.row,coords.col)
//       })
//   }
var hotTableClickEdit = function hotTableClickEdit(hot) {
  var _this = this;
  var isEditing = false;
  hot.hotInstance.addHook('afterSelectionEnd', function (startRow, startCol, endRow, endCol) {
    if (isEditing) {
      return; // 如果已经在编辑状态，不执行后续操作
    }
    // 在选择操作完成后，更新已选择的单元格
    console.log('有没有进入', startRow, startCol, endRow, endCol, _this.$refs.hotTable.hotInstance);
    var selectedCell = {
      row: endRow,
      col: endCol
    };
    if (selectedCell.row < 0 || selectedCell.col < 0) return;
    isEditing = true;
    hot.startEdit(selectedCell.row, selectedCell.col);
    // 在编辑状态结束后，重置标志位
    setTimeout(function () {
      isEditing = false;
    });
    // 在这里可以使用 selectedCell.row 和 selectedCell.col 获取切换后单元格的行列索引
    console.log("切换后单元格的行索引：" + selectedCell.row);
    console.log("切换后单元格的列索引：" + selectedCell.col);
  });
};
var _default = exports.default = hotTableClickEdit;